import React from "react";
import { Tab, Tabs } from "@mui/material";

const MOBILE_TABS_SX = {
  width: "100%",
  minHeight: 48,
  "& .MuiTabs-scroller": {
    overflowX: "auto !important",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
  "& .MuiTabs-flexContainer": { gap: 0 },
  "& .MuiTabs-indicator": {
    height: 2,
    borderRadius: "999px",
    bgcolor: "#2E1834",
  },
  "& .MuiTab-root": {
    flexShrink: 0,
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 500,
    minHeight: 48,
    minWidth: "auto",
    px: 2,
    py: 1.25,
    color: "#9CA3AF",
    whiteSpace: "nowrap",
    "&:hover": { color: "#6B7280" },
    "&.Mui-selected": {
      color: "#151515",
      fontWeight: 600,
    },
  },
};

const DESKTOP_TABS_SX = {
  alignSelf: "stretch",
  width: 260,
  flexShrink: 0,
  borderRight: "1px solid #EFEFEF",
  "& .MuiTabs-indicator": {
    left: 0,
    right: "auto",
    width: 3,
    borderRadius: "0 4px 4px 0",
    bgcolor: "#2E1834",
  },
  "& .MuiTabs-flexContainer": { gap: 0 },
  "& .MuiTab-root": {
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
    color: "#6B7280",
    bgcolor: "#fff",
    minHeight: 56,
    py: 2,
    pl: 3,
    pr: 2,
    justifyContent: "flex-start",
    alignItems: "center",
    borderBottom: "1px solid #F0F0F0",
    transition:
      "color 0.2s ease, background-color 0.2s ease, font-weight 0.2s ease",
    "& .MuiTab-iconWrapper": {
      marginRight: 1.5,
      marginBottom: "0 !important",
      color: "#6B7280",
      transition: "color 0.2s ease",
    },
    "& svg": {
      fontSize: 20,
      width: 20,
      height: 20,
    },
    "&:hover": {
      color: "#151515",
      bgcolor: "rgba(46, 24, 52, 0.03)",
      "& .MuiTab-iconWrapper": { color: "#151515" },
    },
    "&.Mui-selected": {
      color: "#151515",
      fontWeight: 600,
      "& .MuiTab-iconWrapper": { color: "#151515" },
    },
    "&:last-of-type": { borderBottom: "none" },
  },
};

/**
 * Renders horizontal scroll tabs on mobile and vertical sidebar tabs on lg+.
 * Uses CSS visibility instead of JS breakpoint checks to avoid layout flash.
 */
export function SettingsTabs({ tabs, value, onChange }) {
  const tabProps = {
    value,
    onChange: (_, v) => onChange(v),
    variant: "scrollable",
    scrollButtons: false,
    allowScrollButtonsMobile: false,
  };

  return (
    <>
      <nav
        aria-label="Settings sections"
        className="min-w-0 border-b border-[#EFEFEF] lg:hidden"
      >
        <Tabs orientation="horizontal" {...tabProps} sx={MOBILE_TABS_SX}>
          {tabs.map((t, i) => (
            <Tab
              key={t.key}
              id={`settings-tab-${t.key}`}
              value={i}
              label={t.label}
            />
          ))}
        </Tabs>
      </nav>

      <nav
        aria-label="Settings sections"
        className="hidden shrink-0 lg:block"
      >
        <Tabs orientation="vertical" {...tabProps} sx={DESKTOP_TABS_SX}>
          {tabs.map((t, i) => (
            <Tab
              key={t.key}
              id={`settings-tab-${t.key}`}
              value={i}
              label={t.label}
              icon={t.icon}
              iconPosition="start"
            />
          ))}
        </Tabs>
      </nav>
    </>
  );
}
